import { BaseDTO } from './basedto';
import { DunnageType } from './dunnagetype';

export class ProposalPackageLevelDunnageType extends BaseDTO {
    Description:string;
    ProposalPackageLevelId: number;
    DunnageTypeId: number;
    constructor(init?: Partial<ProposalPackageLevelDunnageType>) {
        super();
        Object.assign(this, init);
    }
}